<ib-icon *ngFor='let icon of icons.list; let i=index; trackBy: getIconID '
  [icon]= 'icon'
  class= 'isClickable(icon.id)'
  (click)= 'onToolbarClick($event, icon, i)' >
</ib-icon>
